import type { Cosmetic } from "./types.js";
export const cosmeticSlot = (item: Pick<Cosmetic, "category">) =>
  item.category === "ct" || item.category === "t" ? "agent" : item.category;
export function singleAgentLoadout(
  equipped: Record<string, string>,
  team = "ct",
) {
  return {
    agent: equipped.agent ?? equipped[team] ?? "ct-default",
    knife: equipped.knife ?? "knife-default",
    gloves: equipped.gloves ?? "gloves-default",
  };
}
